/* Small, one-shot reveals. Content stays visible without JavaScript or motion. */
(function () {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const animations = new Set();
    const ease = 'cubic-bezier(.16,1,.3,1)';
    let observer;
    const revealed = new WeakSet();
    const ownedAnimations = new WeakMap();
    function play(element, distance, delay) {
        if (reduced.matches || !element.animate) return;
        const animation = element.animate([
            {opacity: .25, transform: 'translateY(' + distance + 'px)'},
            {opacity: 1, transform: 'translateY(0)'}
        ], {duration: 600, delay: delay || 0, easing: ease, fill: 'backwards'});
        animations.add(animation);
        const owner = element.closest('.gh-card,.studio-news-item') || element;
        if (!ownedAnimations.has(owner)) {
            ownedAnimations.set(owner, new Set());
            owner.addEventListener('focusin', function () {
                ownedAnimations.get(owner).forEach(active => active.cancel());
            });
        }
        const owned = ownedAnimations.get(owner);
        owned.add(animation);
        animation.onfinish = animation.oncancel = function () {
            animations.delete(animation);
            owned.delete(animation);
        };
    }
    function revealHeading(heading, delay) {
        delay = delay || 0;
        if (reduced.matches) return;
        // Preserve authored links, emphasis, icons and other rich heading content.
        if (heading.children.length) { play(heading, 12, delay); return; }
        const text = heading.textContent.trim();
        if (!text) return;
        const words = text.split(/\s+/);
        if (words.length > 24) { play(heading, 12, delay); return; }
        heading.setAttribute('aria-label', text);
        const fragment = document.createDocumentFragment();
        const spans = words.map(function (word) {
            const span = document.createElement('span');
            span.className = 'studio-title-word';
            span.textContent = word;
            span.setAttribute('aria-hidden', 'true');
            fragment.append(span, document.createTextNode(' '));
            return span;
        });
        // A single wrapper preserves flex-heading gaps and natural word spacing.
        const line = document.createElement('span');
        line.setAttribute('aria-hidden', 'true');
        line.append(fragment);
        heading.replaceChildren(line);
        spans.forEach(function (span, index) { play(span, 14, delay + Math.min(index * 28, 168)); });
    }
    document.querySelectorAll('.gh-article-title, .studio-index-title').forEach(heading => revealHeading(heading));

    function revealBatch(elements) {
        const groups = new Map();
        elements.forEach(function (element) {
            if (revealed.has(element)) return;
            revealed.add(element);
            if (element.matches('.gh-card,.studio-news-item')) {
                const group = element.closest('.gh-feed,.studio-news') || element.parentElement;
                const index = groups.get(group) || 0;
                groups.set(group, index + 1);
                const delay = Math.min(index * 85, 255);
                play(element, 12, delay);
                const title = element.querySelector('.gh-card-title,.studio-news-copy h3');
                if (title) revealHeading(title, delay + 45);
            } else if (element.matches('h2,h3')) revealHeading(element);
            else play(element, 12);
        });
    }
    function setupScrollReveals() {
        if (reduced.matches || !('IntersectionObserver' in window)) return;
        const initialBottom = window.scrollY + window.innerHeight;
        const introduced = new WeakSet();
        const homeTargets = '.studio-layout > div > .studio-section-label, ' +
            '.studio-news > .studio-section-label, .studio-game-info h3, ' +
            '.studio-game-info p, .studio-game-text-link';
        // The artwork paints normally. Only small foreground elements enter after load.
        if (document.querySelector('.studio')) {
            const visible = Array.from(document.querySelectorAll(homeTargets)).filter(function (element) {
                const rect = element.getBoundingClientRect();
                return rect.bottom > 0 && rect.top < window.innerHeight;
            });
            visible.forEach(element => introduced.add(element));
            revealBatch(visible);
        }
        // One observer, no scroll handler, no pre-hidden content, no image/glow filters.
        observer = new IntersectionObserver(function (entries) {
            const entering = entries.filter(entry => entry.isIntersecting);
            entering.forEach(entry => observer.unobserve(entry.target));
            revealBatch(entering.map(entry => entry.target));
        }, {threshold: 0, rootMargin: '0px 0px -24px 0px'});
        const visibleCards = [];
        document.querySelectorAll(
            '.studio-section-label, .gh-container-title, .studio-news-item, .gh-card, ' +
            '.studio-game-info h3, .studio-game-info p, .studio-game-text-link, .studio-other-game, ' +
            '.gh-content > h2, .gh-content > h3, .gh-content > figure, ' +
            '.gh-content > .kg-gallery-card, .gh-content > blockquote'
        ).forEach(function (element) {
            // Never re-animate content already read or delay the initial viewport.
            if (introduced.has(element)) return;
            const rect = element.getBoundingClientRect();
            if (rect.top + window.scrollY < initialBottom) {
                if (rect.bottom > 0 && element.matches('.gh-card,.studio-news-item')) visibleCards.push(element);
                return;
            }
            observer.observe(element);
        });
        revealBatch(visibleCards);
        document.addEventListener('focusin', function (event) {
            const target = event.target.closest('.gh-card,.studio-news-item,figure,.kg-gallery-card');
            if (target) observer.unobserve(target);
        });
    }
    function deferScrollSetup() {
        if ('requestIdleCallback' in window) requestIdleCallback(setupScrollReveals, {timeout: 1200});
        else setTimeout(setupScrollReveals, 0);
    }
    if (document.readyState === 'complete') deferScrollSetup();
    else window.addEventListener('load', deferScrollSetup, {once: true});
    reduced.addEventListener('change', function () {
        if (!reduced.matches) return;
        animations.forEach(animation => animation.cancel());
        if (observer) observer.disconnect();
    });
    const content = document.querySelector('.post-template .gh-content');
    if (!content) return;
    const progress = document.createElement('div');
    progress.className = 'studio-reading-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.append(progress);
    let frame;
    function update() {
        frame = null;
        const rect = content.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight * .6);
        const value = Math.max(0, Math.min(1, (window.innerHeight * .2 - rect.top) / distance));
        progress.style.transform = 'scaleX(' + value + ')';
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule);
    update();
})();
